/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPremiumScheduleAvailableForAllocationQueryDto
 */
export interface GetPremiumScheduleAvailableForAllocationQueryDto {
    /**
     * Broker ID to filter by
     * @type {string}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    brokerId: string;
    /**
     * Settlement currency
     * @type {string}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    settlementCurrency: GetPremiumScheduleAvailableForAllocationQueryDtoSettlementCurrencyEnum;
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    pageSize?: number;
    /**
     * Filter by insured IDs
     * @type {Array<string>}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    insuredIds?: Array<string>;
    /**
     * Filter by reinsured IDs
     * @type {Array<string>}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    reinsuredIds?: Array<string>;
    /**
     * Filter by binder IDs
     * @type {Array<string>}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    binderIds?: Array<string>;
    /**
     * Filter by original currencies
     * @type {Array<string>}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    originalCurrencies?: Array<GetPremiumScheduleAvailableForAllocationQueryDtoOriginalCurrenciesEnum>;
    /**
     * Filter by PPW due date from (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    ppwDueDateFrom?: Date;
    /**
     * Filter by PPW due date to (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumScheduleAvailableForAllocationQueryDto
     */
    ppwDueDateTo?: Date;
}


/**
 * @export
 */
export const GetPremiumScheduleAvailableForAllocationQueryDtoSettlementCurrencyEnum = {
    Aud: 'AUD',
    Usd: 'USD',
    Nzd: 'NZD'
} as const;
export type GetPremiumScheduleAvailableForAllocationQueryDtoSettlementCurrencyEnum = typeof GetPremiumScheduleAvailableForAllocationQueryDtoSettlementCurrencyEnum[keyof typeof GetPremiumScheduleAvailableForAllocationQueryDtoSettlementCurrencyEnum];

/**
 * @export
 */
export const GetPremiumScheduleAvailableForAllocationQueryDtoOriginalCurrenciesEnum = {
    Aud: 'AUD',
    Usd: 'USD',
    Nzd: 'NZD'
} as const;
export type GetPremiumScheduleAvailableForAllocationQueryDtoOriginalCurrenciesEnum = typeof GetPremiumScheduleAvailableForAllocationQueryDtoOriginalCurrenciesEnum[keyof typeof GetPremiumScheduleAvailableForAllocationQueryDtoOriginalCurrenciesEnum];


/**
 * Check if a given object implements the GetPremiumScheduleAvailableForAllocationQueryDto interface.
 */
export function instanceOfGetPremiumScheduleAvailableForAllocationQueryDto(value: object): value is GetPremiumScheduleAvailableForAllocationQueryDto {
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('settlementCurrency' in value) || value['settlementCurrency'] === undefined) return false;
    return true;
}

export function GetPremiumScheduleAvailableForAllocationQueryDtoFromJSON(json: any): GetPremiumScheduleAvailableForAllocationQueryDto {
    return GetPremiumScheduleAvailableForAllocationQueryDtoFromJSONTyped(json, false);
}

export function GetPremiumScheduleAvailableForAllocationQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPremiumScheduleAvailableForAllocationQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerId': json['brokerId'],
        'settlementCurrency': json['settlementCurrency'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'insuredIds': json['insuredIds'] == null ? undefined : json['insuredIds'],
        'reinsuredIds': json['reinsuredIds'] == null ? undefined : json['reinsuredIds'],
        'binderIds': json['binderIds'] == null ? undefined : json['binderIds'],
        'originalCurrencies': json['originalCurrencies'] == null ? undefined : json['originalCurrencies'],
        'ppwDueDateFrom': json['ppwDueDateFrom'] == null ? undefined : (new Date(json['ppwDueDateFrom'])),
        'ppwDueDateTo': json['ppwDueDateTo'] == null ? undefined : (new Date(json['ppwDueDateTo'])),
    };
}

export function GetPremiumScheduleAvailableForAllocationQueryDtoToJSON(json: any): GetPremiumScheduleAvailableForAllocationQueryDto {
    return GetPremiumScheduleAvailableForAllocationQueryDtoToJSONTyped(json, false);
}

export function GetPremiumScheduleAvailableForAllocationQueryDtoToJSONTyped(value?: GetPremiumScheduleAvailableForAllocationQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerId': value['brokerId'],
        'settlementCurrency': value['settlementCurrency'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'insuredIds': value['insuredIds'],
        'reinsuredIds': value['reinsuredIds'],
        'binderIds': value['binderIds'],
        'originalCurrencies': value['originalCurrencies'],
        'ppwDueDateFrom': value['ppwDueDateFrom'] == null ? undefined : ((value['ppwDueDateFrom']).toISOString()),
        'ppwDueDateTo': value['ppwDueDateTo'] == null ? undefined : ((value['ppwDueDateTo']).toISOString()),
    };
}

